import $ from 'jquery';
import profileLevel from './profile-level';
import Silder from './slider';
import youtubePlayer from './youtube-player';
import timerDo from './timer-do';
import ratingTab from './rating-tab';

window.Gostop = {
  ui: {
    player: youtubePlayer
  }
};

$.fn.timerDo = timerDo;

export function initializeUI(app) {
  // 유저 레벨에 따른 색 구분
  profileLevel();

  ratingTab();

  // 메인 배너 슬라이드
  var bannerSlider = new Silder({
    container: '.pslider',
    slides: '.pslider__link',
    images: '.pslider__image',

    listContainer: '.pslider__list',
    listTag: '<a href="#" class="pslider__title" data-target="{slideId}">{altText}</a>',
    listActiveClass: 'pslider--active',
    listPerPage: 3,
    listPageWidth: 618,
    listWidth: 206,
    blankList: '.pslider__blank',
    isMoveByPage: true,

    startIndex: 'random',
    prevSlide: '.pslider__prev',
    nextSlide: '.pslider__next',

    pagination: true,
    pageContainer: '.pslider__paging',
    pageTag: '<a href="#" class="pslider__page" data-target="{slideId}">{altText}</a>'
  });

  bannerSlider.start(function () {
    $(this).timerDo(function () {
      $(this).find('.pslider__next').click();
    });

    $(this).find('.pslider__banners').show();
  });

  $(window).on('load', function () {
    $('#game-start-video').addClass('video-playing');
  });

  if (window.matchMedia) {
    window.matchMedia('screen and (max-width: 1060px)').addListener(function (mql) {
      if (mql.matches) {
        $('body').addClass('narrow-viewport');
      } else {
        $('body').removeClass('narrow-viewport');
      }
    });
  }

  app.on('ui:maintain', function () {
    var targets = [
      '.game-start__bg',
      '.game-start__line-off',
      '.game-start__line-on',
      '.game-start__bulbs'
    ];

    $('.game-start')
      .addClass('game-start--disabled')
      .find('.game-start__status')
      .text('게임서비스 점검 중입니다.');

    $(targets.join(',')).remove();
  });
}
